module.exports = __webpack_public_path__ + "img/Bosnia and Herzegovina.c9691982.gif";